import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ConfirmActionDialogData {
  title: string
  message: string
  // Optional bit of content (e.g. a URL or filename) to call out in bold below the message.
  highlight?: string
  confirmText?: string
  cancelText?: string
  confirmColor?: 'primary' | 'accent' | 'warn'
  askReason?: boolean
  reasonLabel?: string
  reasonPlaceholder?: string
  reasonRequired?: boolean
}

@Component({
  selector: 'app-confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.css'],
})
export class ConfirmActionDialogComponent {
  reason = ''

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmActionDialogData,
    public dialogRef: MatDialogRef<ConfirmActionDialogComponent>
  ) {}

  get isConfirmDisabled(): boolean {
    return !!this.data.reasonRequired && !this.reason.trim()
  }

  confirm(): void {
    this.dialogRef.close({
      confirmed: true,
      reason: this.reason.trim() || undefined,
    })
  }
}
